import {Component, Input, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import {Question} from '../../models/definition/question';
import {Category} from '../../models';
import {ProjectAnalysisDefinition} from "../../models/project-analysis";
import {ProjectAnalysisAnswers} from "../../models/project-analysis/project-analysis-answers";
import {CategoryInfos} from "../../models/project/category-info";

@Component({
    selector: 'app-pdf-page-project-analysis-list',
    templateUrl: './pdf-page-project-analysis-list.component.html',
    styleUrls: ['./pdf-page-project-analysis-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PdfPageProjectAnalysisListComponent {
    @Input()
    public projectAnalysisAnswers: ProjectAnalysisAnswers;
    @Input()
    public projectAnalysisDefinition: ProjectAnalysisDefinition;
    @Input()
    public isQuickScan: boolean;
    @Input()
    public categoryInfo: CategoryInfos;

    public getQuestionAnswer(question: Question): string {
        const quickscanAnswer = this.projectAnalysisAnswers.getQuickscanAnswerForQuestion(question);
        const possibleAnswer = question.possibleAnswers.find((answer) => quickscanAnswer && quickscanAnswer.answerId === answer.id);

        return possibleAnswer && possibleAnswer.answer ? possibleAnswer.answer.trim() : '';
    }

    public trackCategory(index: number, category: Category): string {
        return `${category.id}`;
    }

    public trackCategoryQuestion(index: number, question: Question): string {
        return `${index}_${question.id}`;
    }

    public getQuestionRemark(question: Question): string {
        const quickscanAnswer = this.projectAnalysisAnswers.getQuickscanAnswerForQuestion(question);

        return quickscanAnswer && quickscanAnswer.remarks ? quickscanAnswer.remarks.trim() : '';
    }

    public hasQuestionRemark(question: Question): boolean {
        return this.getQuestionRemark(question) !== '';
    }

    public getCategoryRemark(category: Category): string {
        const remark = this.categoryInfo?.getRemarkForCategory(category);
        return remark ? remark.trim() : '';
    }

    public hasCategoryRemark(category: Category): boolean {
        return this.getCategoryRemark(category) !== '';
    }
}
